import { createGlobalStyle } from "styled-components";
//#ff3465
export const lightTheme = {
    bodyBg: '#e3e3e3',
    bodyText: '#2d1945'
};
export const darkTheme = {
    bodyBg: '#2d1945',
    bodyText: '#e3e3e3'
};
export const GlobalStyles = createGlobalStyle `
    body{
        background: ${props => props.theme.bodyBg};
        color: ${props => props.theme.bodyText};
    }
    .navbar-global-style{
        color: ${props => props.theme.bodyText};
        text-decoration: none;
        margin: 5px;
        font-weight: 800;
    }
    .navbar-global-style:hover, .nav-active-style{
        color: #ff3465;
        border-bottom: 5px solid #ff3465;
    }
    .btn-global-style-solid{
        background: #ff3465; 
        color: ${props => props.theme.bodyText};
        font-weight: 600;
    }
    .btn-global-style-solid:hover{
        background: ${props => props.theme.bodyText}; 
        color: #ff3465;
    }
    .btn-global-style{
        color: #ff3465;
        font-weight: 600;
    }
    .btn-global-style:hover{
        border: 4px solid #ff3465;
        color: #ff3465;
    }
    .style-font{
        font-size: 35px;
        font-family: 'Hurricane', cursive;
    }
    .style-font::before{
        content: "⭕ ";
    }
`


